import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AdministratorGuard implements CanActivate {

    constructor(private authService: AuthService) {
    }

    canActivate(
        _next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        void _next;
        void _state;

        return this.authService.user.pipe(
            filter((user): user is NonNullable<typeof user> => user !== undefined),
            take(1),
            map((user) => user.isAdministrator === true)
        );
    }
}
